import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * iter-103 — Magic-link landing page for system-admin "Open as admin"
 * support shortcut. Reads ?token=... , stashes it as the auth token, decodes
 * the JWT payload to surface the impersonation banner, then bounces to /.
 */
export default function Impersonate() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      // Drop any existing session first so we don't keep the system-admin's
      // own user session leaking through into the impersonated tab.
      localStorage.setItem("token", token);
      // Decode the payload (base64url) just enough to read claims.
      const payload = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
      if (payload.impersonated_by) {
        localStorage.setItem(
          "impersonation",
          JSON.stringify({
            by: payload.impersonated_by,
            target_email: payload.impersonated_target_email || null,
            band_id: payload.impersonation_band_id || null,
            exp: payload.exp || null,
          })
        );
      }
    } catch {
      /* swallow — token might be malformed, dashboard will redirect to login */
    }
    navigate("/", { replace: true });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Signing you in as the band's admin…
    </div>
  );
}
